// Shared table styling constants

// Cell-hover spotlight: applied to data tables for video/presentation pointing.
// Hover any body cell to spotlight it with a 3px app-blue outline + white fill.
// `outlineOffset: -3px` keeps the outline inside the cell so adjacent cells don't shift.
export const CELL_HOVER_SPOTLIGHT = {
  backgroundColor: '#fff !important',
  outline: '2px solid #1976d2',
  outlineOffset: '-1px',
};

// Blue-themed Tooltip props matching the app's click-toggle explanation panels.
// Use for rich multi-paragraph hover tooltips on InfoIcons.
export const BLUE_TOOLTIP_PROPS = {
  componentsProps: {
    tooltip: {
      sx: {
        backgroundColor: '#f0f7ff',
        color: 'text.primary',
        borderLeft: '3px solid #1565c0',
        borderRadius: 1,
        p: 1.5,
        maxWidth: 420,
        fontSize: '0.875rem',
        lineHeight: 1.6,
        boxShadow: 3,
        userSelect: 'text',
        pointerEvents: 'auto',
      },
    },
    arrow: {
      sx: { color: '#f0f7ff' },
    },
  },
};

// Smaller variant for short single-line hints (e.g., "Click for explanation").
export const BLUE_TOOLTIP_HINT_PROPS = {
  componentsProps: {
    tooltip: {
      sx: {
        backgroundColor: '#f0f7ff',
        color: 'text.primary',
        border: '1px solid #1565c0',
        borderRadius: 1,
        px: 1,
        py: 0.5,
        fontSize: '0.75rem',
        boxShadow: 2,
      },
    },
    arrow: {
      sx: { color: '#f0f7ff', '&::before': { border: '1px solid #1565c0' } },
    },
  },
};
